import React from 'react';
import CatalogManager from '../components/CatalogManager';

export default function Brands() {
  return (
    <div className="space-y-6" data-testid="brands-page">
      <CatalogManager standalone singleTab defaultTab="brands" />
    </div>
  );
}
